

























































































































































import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, EstadoEntidad, TipoAlertaBase } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModalCrear from '@/reusable/Modal/CabeceraModalCrear.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { Validator } from 'vee-validate';

import moment, { Duration } from 'moment';
import config from '@/config/index';
import Confirmation from '@/components/Confirmation.vue';
import { FormChangeEvent } from '@/reusable/Form/formUtils';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';

import ConfigurarAlertaForm from '@/pantallas/Alertas/ConfigurarAlertaForm.vue';
import ConfigurarNotificacionForm from '@/pantallas/Alertas/ConfigurarNotificacionForm.vue';

import {
  AlertaBackend,
  CampoDinamico,
  UsoNoAutorizado,
  ZonaAlerta,
  ZonaAlertaGrillaDetencion,
} from '@/interfaces/Alertas';
import {
  typeConfigBase,
  typeNuevosCampo,
  AlertasBaseBackend,
} from '@/pantallas/ConfigurarBase/ConfiguracionBase';

import {
  Etiqueta,
  Flota,
  Vehiculo,
} from '@/reusable/AsociarFlotaEtiquetaVehiculoV2/fetchFlotasEtiquetasVehiculos';

import { ColDef } from 'ag-grid-community';

import AsociarFlotaEtiquetaVehiculo, {
  AsociarFlotaEtiquetaVehiculoChangeEvent,
} from '@/reusable/AsociarFlotaEtiquetaVehiculoV2/AsociarFlotaEtiquetaVehiculo.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { OperacionCrud } from '@/reusable/Mantenedor/OperacionCrud';
import MensajeValidacion from '@/reusable/Mantenedor/MensajeValidacion.vue';
import AsociarFlotaEtiquetaVehiculoXMantenimiento from '@/pantallas/Informes/partes/AsociarFlotaEtiquetaVehiculoXMantenimiento.vue';

@Component({
  components: {
    Confirmation,
    ModalMantenedor,
    CabeceraModalCrear,
    CabeceraModal,
    CrudStepperContent,
    CrudStepperItems,
    CrudStepperHeader,
    CrudStepsNavBar,
    NavegacionModalCrud,
    ConfigurarAlertaForm,
    AsociarFlotaEtiquetaVehiculo,
    ConfigurarNotificacionForm,
    MensajeValidacion,
    AsociarFlotaEtiquetaVehiculoXMantenimiento,
  },
})
export default class CrearAlertaModal extends OperacionCrud {
  @Prop({ required: true }) show: boolean;
  @Prop({ required: false }) alerta: any;
  @Prop({ required: false, default: false }) edit: boolean;

  //abstract
  funcionalidad: Funcionalidades = Funcionalidades.Alertas;
  permisosActuales: PermisoAccionVm[] = [];

  readonly pasos: PasosCrud = {
    configurarAlerta: {
      accion: 'Crear - Configurar Alerta',
      visible: true,
      step: 1,
      title: 'Configurar Alerta',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
    asociarVehiculos: {
      accion: 'Crear - Asociar Flotas Etiquetas o Vehículos',
      visible: true,
      step: 2,
      title: 'Asociar Vehículos',
      icon: 'directions_car',
      codigoSubAccion: 41,
      codigoAccionPadre: CodigoAccion.Crear,
    },
    configurarNotificaciones: {
      accion: 'Crear - Configurar Notificaciones',
      visible: true,
      step: 3,
      title: 'Configurar Notificación',
      icon: 'person',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 42,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  asociaciones: AsociarFlotaEtiquetaVehiculoChangeEvent = {
    flotas: [],
    etiquetas: [],
    vehiculos: [],
  };

  vehiculoColDefs: ColDef[] = [
    {
      headerName: 'Código',
      field: 'id',
      hide: true,
    },
    {
      headerName: 'Unidad',
      field: 'unidad',
      lockVisible: true,
      lockPinned: true,
    },
    {
      headerName: 'Referencia',
      field: 'referencia',
    },
  ];

  // Variables Globales
  readonly $snotify: Snotify;
  pasoActivoIndex: number = 1;
  isValidCampos = true;
  dialogConfirmacionGuardar: boolean = false;
  mensajeConfirmacion: any = '';
  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  loadingService = new LoadingService();
  tipoBase: number = -1;
  esAcumulable: boolean = false;

  // alerta: any = {};

  /* validacion */
  showValidacion: boolean = false;
  showValidacionLineal: boolean = false;
  tituloValidacion: any = '';
  mensajeValidacion: any = '';
  itemsNoValidos: string[] = [];
  isValidCamposZonas = true;
  showAsociarVehiculos = true;
  valid = false;

  tipoNotificacionSeleccionado: number = 1;
  listaDistribucionSeleccionados: number[] = [];
  contactosSeleccionados: number[] = [];
  idsPlanesSeleccionados: number[] = [];
  usuariosSeleccionados: number[] = [];
  camposZonaEmpty: any = '';

  //controllers
  readonly Controller: string = 'Alerta';

  constructor() {
    super();
    this.pasos.configurarAlerta.permitirContinuar = this.permitirContinuarConfigurarAlerta;
    this.pasos.asociarVehiculos.permitirContinuar = this.permitirContinuarAsociarVehiculos;
    this.pasos.configurarNotificaciones.permitirContinuar = this.permitirContinuarConfigurarNotificaciones;
  }

  created() {
    // this.chequearPermisos();
  }

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    // console.log('alerta ->', this.alerta.jconf.vehiculo);
    this.alerta.nombre_conf = this.alerta.Nombre;
    this.alerta.tiempo_conf =
      this.alerta.tiempo_analisis == undefined
        ? 0
        : this.alerta.tiempo_analisis / 60;
    this.alerta.velocidad = this.alerta.velocidad_detencion;
    this.alerta.variacion = this.alerta.variacion_combustible;
    // this.alerta = {};
    this.$validator.reset();
  }

  handleCerrar() {
    this.alerta = {};
    this.listaDistribucionSeleccionados = [];
    this.contactosSeleccionados = [];
    this.usuariosSeleccionados = [];
    this.idsPlanesSeleccionados = [];
    this.pasoActivoIndex = 1;
    this.$validator.reset();
    this.$emit('cerrar');
  }

  async handleGuardar() {
    this.mensajeConfirmacion =
      '¿Está seguro que desea guardar los cambios realizados?';
    this.dialogConfirmacionGuardar = true;
  }

  handleEstadoSwitch(isActivo: boolean) {
    if (!isActivo) {
      this.mensajeConfirmacion =
        'Al dejar como inactivo, no se permitirá recibir notificaciones de esta Alerta. ¿Esta seguro que desea crear la Alerta?';
    } else {
      this.mensajeConfirmacion = this.$t('mensajes.crud.crear.mensaje', {
        entidad: 'la Alerta',
      });
    }
  }

  handleConfirmacionGuardar(val: boolean) {
    this.dialogConfirmacionGuardar = false;

    if (val) {
      this.loadingService.showLoading();

      this.alerta.flotasId = this.asociaciones.flotas.map((x: Flota) => x.id);
      this.alerta.etiquetasId = this.asociaciones.etiquetas.map(
        (x: Etiqueta) => x.id
      );
      this.alerta.vehiculos = this.asociaciones.vehiculos.map(
        (x: Vehiculo) => x.id
      );
      this.alerta.id_cliente = this.getClientID().toString();
      this.alerta.id_user = this.getUserID().toString();
      this.alerta.estado = 1;

      var notificarForm = this.pasos.configurarNotificaciones.formState.entity;
      this.alerta.notificaGps = notificarForm.notificaGps;
      this.alerta.notificaBrowser = notificarForm.notificaBrowser;
      this.alerta.notificaEmail = notificarForm.notificaEmail;
      // if(!this.edit){
      //   this.alerta.tiempo_conf = this.alerta.tiempo_conf
      // }
      // console.log(this.alerta);
      // return;

      this.loadingService.hideLoading();
      var ruta = '';
      if (this.alerta.id_conf != '' && this.alerta.id_conf != null) {
        ruta = 'UpdConfiguracionByID';
      } else {
        ruta = 'postConfiguracion';
      }
      this.axios.http
        .post(
          `Metabase/PostgenericA/conf_fuga_combustible/${ruta}`,
          this.alerta
        )
        .then(res => {
          this.$snotify.success(
            this.$t('mensajes.mensajesExito.crear', {
              entidad: 'Alerta',
              creadoA: 'creada',
            })
          );
          this.handleCerrar();
          this.loadingService.hideLoading();
        })
        .catch(error => {
          this.loadingService.hideLoading();
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              this.$snotify.error(
                this.$t('mensajes.mensajesError.crear', {
                  entidad: 'Alerta',
                })
              );
            }
          } else {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'Alerta',
              })
            );
          }
        });
    }
  }

  /* Configurar Alerta */

  handleFormChange(event: FormChangeEvent) {
    this.pasos.configurarAlerta.formState = event;
  }

  handleTipoBaseChange(tipoBase: number, esAcumulable: boolean) {
    this.tipoBase = tipoBase;
    this.esAcumulable = esAcumulable;
  }

  // handleParametroGeneral(parametroGeneral: boolean) {
  //   this.alerta.parametroGeneral = parametroGeneral;
  // }

  handleValidaCamposChange(isValid: boolean) {
    this.isValidCampos = isValid;
  }

  // handleCamposDinamicosChange(lstCamposDinamico: CampoDinamico[]) {
  //   this.isValidCampos = true;
  //   this.alerta.campoDinamico = lstCamposDinamico;
  // }

  // handleUsoNoAutorizadoChange(lstUsoNoAutorizado: UsoNoAutorizado[]) {
  //   this.alerta.usoNoAutorizado = lstUsoNoAutorizado;
  // }

  // handleDatosZonas(lstZonas: ZonaAlerta[]) {
  //   this.isValidCampos = true;
  //   this.alerta.zonas = lstZonas;
  // }

  handlePlanesChange(planes: number[]) {
    this.idsPlanesSeleccionados = planes;
  }

  handleValidaCamposZonas(isValidCamposZonas: boolean) {
    this.isValidCamposZonas = isValidCamposZonas;
  }

  handleCamposZonaEmpty(camposZonaEmpty: any) {
    this.camposZonaEmpty = [];
    if (
      this.tipoBase === TipoAlertaBase.AlertaZona ||
      this.tipoBase === TipoAlertaBase.AlertaRuta
    ) {
      camposZonaEmpty.velocidad == 0
        ? this.camposZonaEmpty.push('Velocidad en km/h')
        : '';

      camposZonaEmpty.tolerancia === 0 || camposZonaEmpty.tolerancia === ''
        ? this.camposZonaEmpty.push('Tolerancia en km/h')
        : '';

      (camposZonaEmpty.eventos == 0 || camposZonaEmpty.eventos == null) &&
      (camposZonaEmpty.temporalidad == 0 ||
        camposZonaEmpty.temporalidad == null)
        ? this.camposZonaEmpty.push('N° de Eventos o Temporalidad')
        : '';
    }
  }

  handleCamposZonaNoAutorizadaEmpty(camposZonaEmpty: any) {
    this.camposZonaEmpty = [];
    camposZonaEmpty.velocidad == 0
      ? this.camposZonaEmpty.push('Velocidad en Km/h')
      : '';

    camposZonaEmpty.tolerancia === 0 || camposZonaEmpty.tolerancia === ''
      ? this.camposZonaEmpty.push('Tolerancia en Km/h')
      : '';
    camposZonaEmpty.eventos == 0 && camposZonaEmpty.temporalidad == 0
      ? this.camposZonaEmpty.push('N° de Eventos o Temporalidad')
      : '';
  }

  handlecamposDetencionNoAutorizadaEmpty(
    camposDetencionEmpty: ZonaAlertaGrillaDetencion
  ) {
    this.camposZonaEmpty = [];
    const alertaForm = this.pasos.configurarAlerta.formState.entity;

    if (alertaForm.estadoIgnicion) {
      camposDetencionEmpty.eventos === 0 || camposDetencionEmpty.eventos === '0'
        ? this.camposZonaEmpty.push('N° de Eventos')
        : '';

      camposDetencionEmpty.temporalidad === 0 ||
      camposDetencionEmpty.temporalidad === '0'
        ? this.camposZonaEmpty.push('Temporalidad')
        : '';
      camposDetencionEmpty.tiempoDetencion === 0 ||
      camposDetencionEmpty.tiempoDetencion === '0'
        ? this.camposZonaEmpty.push('Tiempo de detención')
        : '';
    } else {
      camposDetencionEmpty.tiempoDetencion === 0 ||
      camposDetencionEmpty.tiempoDetencion === '0'
        ? this.camposZonaEmpty.push('Tiempo de detención')
        : '';
    }
  }

  handleShowAsociarVehiculos(showAsociarVehiculos: boolean) {
    this.showAsociarVehiculos = showAsociarVehiculos;
  }

  get estadoId() {
    const { entity } = this.pasos.configurarAlerta.formState;
    if (!entity) {
      return null;
    }
    return entity.estado;
  }

  /* Pestaña Asociar vehiculo  */

  handleAsociacionesChange(event: AsociarFlotaEtiquetaVehiculoChangeEvent) {
    this.asociaciones = event;
  }

  /* Pestaña Configurar notificacion  */

  handleDistribucionSelect(
    lstNotificacion: number[],
    tipoNotificacion: number
  ) {
    if (tipoNotificacion == 1) {
      this.alerta.notificacionListaDistribucion = lstNotificacion;
      this.listaDistribucionSeleccionados = lstNotificacion;
    } else if (tipoNotificacion == 2) {
      this.alerta.notificacionContacto = lstNotificacion;
      this.contactosSeleccionados = lstNotificacion;
    } else {
      this.alerta.notificacionUsuario = lstNotificacion;
      this.usuariosSeleccionados = lstNotificacion;
    }
  }

  handleFormNotificarChange(event: FormChangeEvent) {
    this.pasos.configurarNotificaciones.formState = event;
  }

  handleCalendarioSelect(calendarios: number[]) {
    this.alerta.notificacionCalendario = calendarios;
  }

  handledTipoNotificacion(tipoNotificacion: number) {
    this.tipoNotificacionSeleccionado = tipoNotificacion;
  }

  /* Validacion */

  permitirContinuarConfigurarAlerta() {
    this.itemsNoValidos = [];
    this.mensajeValidacion = '';
    this.$validator.validateAll();
    if (
      this.alerta.nombre_conf == '' ||
      this.alerta.nombre_conf == null ||
      this.alerta.tiempo_conf == '' ||
      this.alerta.tiempo_conf == null ||
      this.alerta.velocidad == '' ||
      this.alerta.velocidad == null ||
      this.alerta.variacion == '' ||
      this.alerta.variacion == null ||
      !this.valid
    ) {
      this.tituloValidacion = 'Seleccionar Campos';
      this.mensajeValidacion = 'Por favor validar todos los campos.';
      this.showValidacion = true;
      return false;
    }
    return true;
  }

  permitirContinuarAsociarVehiculos() {
    this.itemsNoValidos = [];
    this.mensajeValidacion = '';

    if (!this.asociaciones.vehiculos.length) {
      this.tituloValidacion = 'Seleccionar Vehículo';
      this.mensajeValidacion = 'Debe seleccionar al menos un Vehículo.';
      this.showValidacion = true;
      return false;
    }
    return true;
  }
  validateNumberPercentage(value: any) {
    const num = parseFloat(value);
    if (isNaN(num)) return 'Por favor ingresar un número.';
    if (num < 0 || num > 100) return 'El número tiene que estar entre 0 y 100.';
    return true;
  }
  validateNumber(value: any) {
    const num = parseFloat(value);
    if (isNaN(num)) return 'Por favor ingresar un número.';
    if (num < 1 || num > 999) return 'El número tiene que estar entre 0 y 999.';
    return true;
  }

  permitirContinuarConfigurarNotificaciones() {
    this.tituloValidacion = 'Configurar Notificación';
    this.mensajeValidacion = 'Debe seleccionar:';
    this.itemsNoValidos = [];

    if (
      this.listaDistribucionSeleccionados.length ||
      this.contactosSeleccionados.length ||
      this.usuariosSeleccionados.length
    ) {
      //
    } else {
      this.itemsNoValidos.push('Lista de Distribución, Contacto o Usuario');
    }

    var notificarForm = this.pasos.configurarNotificaciones.formState.entity;

    if (
      !notificarForm.notificaGps &&
      !notificarForm.notificaBrowser &&
      !notificarForm.notificaEmail
    ) {
      this.itemsNoValidos.push('Medio de Notificación');
    }

    if (
      !this.alerta.notificacionCalendario ||
      this.alerta.notificacionCalendario.length == 0
    ) {
      this.itemsNoValidos.push('Calendario');
    }

    if (this.itemsNoValidos && this.itemsNoValidos.length > 0) {
      this.showValidacion = true;
      return false;
    }

    return true;
  }
  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
    // return 5216;
  }

  handleAsociacionesChangeM(event: any) {
    this.asociaciones.vehiculos = event.vehiculos;
  }
}
